module.exports = __webpack_public_path__ + "img/brasao_do_embaixador.abb91311.svg";